<template>
    <StandardDropdown
        :modelValue="value ? { name: value, key: value } : null"
        :options="ruralStatus"
        placeholder="Select Rural Status"
        class="inter-rule-spacing"
        @change="$emit('handleValueChange', $event.value.key)"
    />
</template>

<script>
import StandardDropdown from '@/components/common/StandardDropdown.vue';
import { RuralStatus } from '@/store/constants';

export default {
    name: 'RuralRule',
    props: ['value'],
    components: { StandardDropdown },
    data() {
        return {
            ruralStatus: RuralStatus,
        };
    },
};
</script>

<style scoped></style>
